// extracted by mini-css-extract-plugin
module.exports = {"header":"TranslationGroup_header__i2C2P","item":"TranslationGroup_item__uc7kH","itemsContainer":"TranslationGroup_itemsContainer__p0HAL"};